import React from 'react'
import ReactDOM from 'react-dom/client'
import { AppProviders } from '@/app/providers'
import { App } from '@/App'
import { installReloadDiag } from '@/lib/reloadDiag'
import '@/index.css'

// Opt-in (?diag=1) reload diagnostic. No-op unless explicitly enabled.
installReloadDiag()

ReactDOM.createRoot(document.getElementById('app')!).render(
  <React.StrictMode>
    <AppProviders>
      <App />
    </AppProviders>
  </React.StrictMode>,
)
